import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { OrderRecordSearchQueryResponse, OrderRecordUpdateResponse, OrderRecordUpdateRequest } from 'app/models/order-records.model';


/**
 * Service for fetching order data from the backend API.
 */
@Injectable({
  providedIn: 'root',
})
export class OrderService {
  /**
   * Constructs the orderService with HttpClient injection.
   * 
   * @param http Angular HttpClient for making HTTP requests
   */
  constructor(private http: HttpClient) { }

  /**
   * Fetches a paginated list of orders from the API.
   * 
   * @param page The page number to fetch (default: 1)
   * @param limit The number of items per page (default: 10)
   * @param search_field Field to search orders by customer name
   * @returns Observable emitting the API response containing order profiles
   */
  getOrderList(page: number = 1, limit: number = 10, search_field: string): Observable<OrderRecordSearchQueryResponse> {

    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });
    const fetchApi: string = `${environment.api_url}//order-records`;
    let params: HttpParams = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    if (search_field) {
      params = params.set('search_field', search_field);
    }
    return this.http.get<OrderRecordSearchQueryResponse>(fetchApi, { params, headers });
  }

  /**
   *Update order for customer show or not show file.
   * 
   * @param order_update order update base on input data   
   * @returns Observable emitting the API response containing customer profiles
   */
  orderUpdate(order_update: OrderRecordUpdateRequest): Observable<OrderRecordUpdateResponse> {

    const token: string | null = localStorage.getItem('token');
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ` ${token}`  // if needed
    });

    const fetchApi: string = `${environment.api_url}/order-records/update`;
    return this.http.post<OrderRecordUpdateResponse>(fetchApi, order_update, { headers });

  }
}